import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_PRE007_Request,
  IAPI_PRE007_Response,
} from "../../../type/apiType";

/**
 * 掛金納付対象職員届作成参照API
 * @return httpPremiumApplicationCreate
 */
const httpAPI_PRE007 = async (
  param: IAPI_PRE007_Request
): Promise<IAPI_PRE007_Response> => {
  let res = await http.post(ApiUrl.API_PRE007, {
    ...param,
  });

  return res.data;
};

export { httpAPI_PRE007 };
